export default __webpack_public_path__ + "static/media/remoteH2.ef8062fe.png";